import React, { Component } from 'react';
import {
    Col, 
    Row, 
    Container, 
    Button, 
    Card, 
    CardBody, 
    CardHeader, 
    Form, 
    FormGroup, 
    Label, 
    Input, 
    Alert, 
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter,
    Table
} from 'reactstrap';
import RequestManager from '../../singletons/RequestManager'
import moment from 'moment'

export default class BenefitProgram extends Component{
    constructor(props){
        super(props)
        this.state = {
            phoneNumberSubmitted:false,
            phone:'+91',
            otp:'',
            firstName:'',
            lastName:'',
            storePromoters:[],
            selectedStoreActivator:null,
            modalVisible:false
        }
    }
    

    componentDidMount(){
        this.fetchStorePromoters()
    }

    fetchStorePromoters = async ()=>{
        let requestManager = new RequestManager()
        let storeInformation = JSON.parse(localStorage.getItem('storeInformation'))

        let loginMode = localStorage.getItem('loginMode')
        if(loginMode != null)
        {
            if(loginMode === 'store'){
                let response = await requestManager.getResponseFromPredefinedQuery('getStorePromoters',{
                storeId:storeInformation.store.id
                })

                if(response.error === null){
                    this.setState({storePromoters:response.data.storePromoters.edges})
                }
            }
        }
        
    }

    onFormSubmit = async(e)=>{
        e.preventDefault()
        e.stopPropagation()

        if(this.state.phoneNumberSubmitted === false){
            let requestManager = new RequestManager()
            let response = await requestManager.getResponseFromPredefinedQuery('updateStoreActivator',{
                input:{
                    phone: this.state.phone
                }
            })

            if(response.error === null && response.data.updateStorePromoter.success === true){
                this.setState({phoneNumberSubmitted:true})
            }else{
                alert('Something went wrong please ensure you have a working internet connection and try again later.')
            }
        }else{
            let storeInformation = JSON.parse(localStorage.getItem('storeInformation'))
            let requestManager = new RequestManager()
            let response = await requestManager.getResponseFromPredefinedQuery('updateStoreActivator',{
                input:{
                    phone: this.state.phone,
                    // eslint-disable-next-line
                    otp:parseInt(this.state.otp),
                    firstName:this.state.firstName,
                    lastName:this.state.lastName,
                    storeId:storeInformation.store.id
                }
            })

            if(response.error === null && response.data.updateStorePromoter.success === true){
                this.resetForm()
                this.fetchStorePromoters()
            }else{
                alert('Something went wrong please ensure you have a working internet connection and try again later.')
            }
        }
    }
    
    resetForm = ()=>{
        this.setState({
            phoneNumberSubmitted:false, 
            phone:'+91',
            otp:'',
            firstName:'',
            lastName:''
        })
    }

    render(){
        let loginMode = localStorage.getItem('loginMode')
        if(loginMode === 'store'){
            return(
                <Container fluid>
                    {this.renderDetailsModal()}
                    <Row style={{marginTop:20}}>
                        <Col>
                            <Card>
                                <CardHeader>
                                    <h5>About the GrabbnGo Store Benefit Program</h5>
                                </CardHeader>
                                <CardBody>
                               </CardBody>
                            </Card>
                        </Col>
                        <Col md='4' sm='12'>
                            <Card>
                                <CardHeader>
                                    <h5>Add a cashier</h5>
                                </CardHeader>
                                <CardBody>
                                    {this.renderAddNewActivatorForm()}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row style={{marginTop:0}}>
                        {
                            this.state.storePromoters.map((storeActivator)=>{
                                return(
                                    <Col md='4' sm='12' key={storeActivator.node.id}>
                                        {this.renderActivatorCard(storeActivator)}
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </Container>
            )
        }else{
            return(
                <Alert className="m-2" color='secondary'>Benefits program is only available on the individual store dashboard. You are logged into manage multiple stores. Please login to a store individually to access the benefits program. Please contact <a href='mailto:help@grabbngo.com'>help@grabbngo.com</a> for further clarifications.</Alert>
            )
        }
    }

    renderAddNewActivatorForm = ()=>{
        return(
            <Form onSubmit={this.onFormSubmit}>
                <FormGroup>
                    <Label>Cashier's phone number</Label>
                    <Input 
                        onChange={event=>this.setState({phone:event.target.value})} 
                        id='activatorPhoneNumber' 
                        name='activatorPhoneNumber' 
                        value={this.state.phone} 
                        disabled={this.state.phoneNumberSubmitted}
                    />
                </FormGroup>
                {
                    this.state.phoneNumberSubmitted && <div>
                        <FormGroup>
                            <Label>Please enter the OTP</Label>
                            <Input 
                                name='otp' 
                                id='otp'
                                value={this.state.otp}
                                onChange={event=>this.setState({otp:event.target.value})}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Please enter first name</Label>
                            <Input 
                                name='firstName' 
                                id='firstName'
                                value={this.state.firstName}
                                onChange={event=>this.setState({firstName:event.target.value})}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Please enter last name</Label>
                            <Input 
                                name='lastName' 
                                id='lastName'
                                value={this.state.lastName}
                                onChange={event=>this.setState({lastName:event.target.value})}
                            />
                        </FormGroup>
                    </div>
                }
                <FormGroup>
                    <div style={{display:'flex', flexDirection:'row'}}>
                        <Button color='success' name='submit' id='submit'>Submit</Button>
                        {this.state.phoneNumberSubmitted && <Button style={{marginLeft:10}} onClick={this.resetForm}>Cancel</Button>}
                    </div>
                </FormGroup>
            </Form>
        )
    }

    renderActivatorCard = (storeActivator)=>{
        return(
            <Card>
                <CardHeader>
                    {storeActivator.node.userProfile.firstName + ' ' + storeActivator.node.userProfile.lastName}
                </CardHeader>
                <CardBody>
                    <p>{'Activation Code: '}<b>{storeActivator.node.phone}</b></p>
                    <p>{'Users signed up: '}<b>{storeActivator.node.referralCount}</b></p>
                    <p>{'Users ordered: '}<b>{storeActivator.node.referralOrderedCount}</b></p>
                    <Button color='secondary' onClick={()=>{
                        this.setState({
                            selectedStoreActivator:storeActivator,
                            modalVisible:true
                        })
                    }}>Details</Button>
                </CardBody>
            </Card>
        )
    }

    renderDetailsModal = ()=>{
        console.log(this.state.selectedStoreActivator)
        if(this.state.selectedStoreActivator !== null){
            return(
                <Modal isOpen={this.state.modalVisible} toggle={()=>this.setState({modalVisible:!this.state.modalVisible})}>
                    <ModalHeader toggle={()=>this.setState({modalVisible:false})}>
                        {this.state.selectedStoreActivator.node.userProfile.firstName + ' ' + this.state.selectedStoreActivator.node.userProfile.lastName}
                    </ModalHeader>
                    <ModalBody>
                        <p>Here are the users signed up by this cashier.</p>
                        <Table striped responsive>
                            <thead>
                                <tr>
                                    <th>User name</th>
                                    <th>Date activated</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.selectedStoreActivator.node.referralChildren.edges.map(referral=>{
                                    return(
                                        <tr key={referral.node.id}>
                                            <td>
                                                {referral.node.child.userProfile.firstName}
                                            </td>
                                            <td>
                                                {moment(referral.node.createdAt).calendar()}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={()=>this.setState({modalVisible:false})}>Done</Button>
                    </ModalFooter>
                </Modal>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/BenefitProgram/BenefitProgram.js